import CryptoJS from "crypto-js";
import axios from "axios";
import dayjs from "dayjs";

const SCALE_TYPES = {
    GRIMM: 'grimm'
}
let connectorToken;

export const getWeightFromScale = async (scaleType, scaleHost, store) => {
    if (!connectorToken) connectorToken = createToken()
    let response
    let weighingResult
    let resultOutput = ''
    let logMessage = ''

    try {
        response = await axios.get(scaleHost +'/api/'+ scaleType +'/send-weighing-cmd', {
            headers: {
                Authorization: `Bearer ${connectorToken}`
            }
        });

        // handle response data
        logMessage = JSON.stringify(response.data);

        weighingResult = await getWeightFromScaleResponse(scaleType, response);
        resultOutput += weighingResult;

        logMessage += "\n\nresult: "+ weighingResult;

    } catch (error) {
        resultOutput = `Fehler: ${error.message}`; // Handle error

        logMessage = JSON.stringify(error.response.data) +"\n\n"+ JSON.stringify(error);
        // send it to support
        store.dispatch('sendEmailMessage', {
            type: 'notifySupport',
            data: {
                subject: resultOutput,
                body: resultOutput +"\n\n"+ logMessage
            }
        })
    }

    return {weighingResult, resultOutput};
}

const getWeightFromScaleResponse = async (scaleType, response) => {
    // let result = null;
    try {
        let responseData = typeof response.data === 'object' ? response.data : JSON.parse(response.data);
        let scaleResponse = responseData.response;

        console.log('responseData', responseData.response);

        // manuell:
        // response = "{\"response\":\"<000002.06.2614:08   01    1560       0    1560kg   001   39670>\\r\\n\"}";
        // let responseData = JSON.parse(response);

        /*/ clear multiple spaces into single space
        responseData.response = responseData.response.replaceAll('       ', '*');
        responseData.response = responseData.response.replaceAll('      ', '*');
        responseData.response = responseData.response.replaceAll('     ', '*');
        responseData.response = responseData.response.replaceAll('    ', '*');
        responseData.response = responseData.response.replaceAll('   ', '*');
        responseData.response = responseData.response.replaceAll('  ', '*');
        responseData.response = responseData.response.replaceAll(' ', '*');
        console.log('responseData.response', responseData.response);

        const parts = responseData.response.split('*');
         */
        return {...mapScaleResponseParts(scaleType, responseData.response), response: scaleResponse };

        // logMessage = JSON.stringify(response.data);
    } catch (error) {
        // result = `Error: ${error.message}`; // Handle error
        // logMessage = JSON.stringify(error.response.data) +"\n\n"+ JSON.stringify(error);
        return { error: `Fehler: ${error.message}` }
    }
}

const mapScaleResponseParts = (scaleType, response) => {
    let result

    switch (scaleType) {
        case SCALE_TYPES.GRIMM:
            result = {
                brutto: Number.parseFloat(response.substring(3,10)),
                tara: Number.parseFloat(response.substring(10,17)),
                netto: Number.parseFloat(response.substring(17,24)),
                number: Number.parseInt(response.substring(26,32)),
                timestamp: dayjs(response.substring(32,46), 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss')
            }
            break
    }

    return result;
}

const createToken = () => {
    const header = {
        alg: "HS256",
        typ: "JWT"
    };

    const payload = {
        data: "examplePayload",
        exp: Math.floor(Date.now() / 1000) + (60 * 60 * 24 * 100) // Token expires in 1 hour
    };

    const secret = process.env.VUE_APP_PS_CONNECTOR_JWT_SECRET;

    // Base64URL encoding function
    const base64UrlEncode = (obj) => {
        // Regular base64 encoding
        const str = btoa(JSON.stringify(obj));
        // Convert to base64url format
        return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    };

    const headerEncoded = base64UrlEncode(header);
    const payloadEncoded = base64UrlEncode(payload);

    // Create the signature using crypto-js
    const signatureInput = `${headerEncoded}.${payloadEncoded}`;
    const signatureWordArray = CryptoJS.HmacSHA256(signatureInput, secret);

    // Convert the signature to base64 and then to base64url
    let signatureBase64 = CryptoJS.enc.Base64.stringify(signatureWordArray);
    const signatureBase64Url = signatureBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

    return `${headerEncoded}.${payloadEncoded}.${signatureBase64Url}`;
}